import dynamic from "next/dynamic";

const UploadFormNoSSR = dynamic(() => import("./UploadForm"), {
  ssr: false,
});

export default (props) => <UploadFormNoSSR buttonIcon={props.icon} buttonLabel={props.label} buttonStyle="contained" />;
